import { render } from "./UserLogin.vue?vue&type=template&id=70f9bd1c&scoped=true"
import script from "./UserLogin.vue?vue&type=script&lang=js"
export * from "./UserLogin.vue?vue&type=script&lang=js"

import "./UserLogin.vue?vue&type=style&index=0&id=70f9bd1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f9bd1c"]])

export default __exports__